module.exports = __webpack_public_path__ + "static/media/BeVietnam-Medium.66240f97.ttf";